import axios from "axios";
import router from "@/router";
import {
  RequestToken,
  RefreshToken,
  GenerateVerificationCode,
  CreateUserAccount,
  ActivateUserLvl1,
  ResetPassword,
  ValidateActivationCode,
  GetOrgAdminLocations,
  GetOrganizations,
  CreateNewLocation,
} from "@/api/auth";

// eslint-disable-next-line import/no-cycle

export const login = ({ commit }, params) =>
  RequestToken(params)
    .then(session => {
      if (session) {
        localStorage.setItem("token", session.refresh_token);
        commit("LOGIN_SUCCESS", session);
        axios.defaults.headers.common.Authorization = `Bearer ${session.access_token}`;
        if (session.account.is_organization_admin) router.push("/admin/locations");
        else if(session.account.type == 'AdditionalRecipient') router.push('/mail');
        else if (session.account.role === "customer") router.push(params.redirect_url || "/");
        else router.push("/");
      } else {
        router.push("/login");
      }
    })
    .catch(e => {
      router.push("/login");
      localStorage.removeItem("token");
      commit("LOGIN_FAIL");

      return new Promise((resolve, reject) => {
        reject(e);
      });
    });

export const refresh = ({ commit }, refToken) =>
  RefreshToken(refToken).then(res => {
    commit("LOGIN_UPDATE", res);
    axios.defaults.headers.common.Authorization = `Bearer ${res.access_token}`;
  });

export const logout = ({ commit }) => {
  // RemoveToken();
  localStorage.removeItem("token");
  sessionStorage.removeItem("is_admin");
  commit("LOGOUT");
  delete axios.defaults.headers.common["Authorization"];
};

export const generateVerificationCode = ({ dispatch }, code) =>
  GenerateVerificationCode(code)
    .then(res => {
      return res;
    })
    .catch(
      e =>
        new Promise((resolve, reject) => {
          reject(e);
        })
    );

export const createUser = ({ commit }, params) =>
  CreateUserAccount(params)
    .then(session => {
      if (session) {
        localStorage.setItem("token", session.refresh_token);
        commit("LOGIN_SUCCESS", session);
        axios.defaults.headers.common.Authorization = `Bearer ${session.access_token}`;
      } else {
        commit("LOGIN_FAIL");
      }
    })
    .catch(e => {
      commit("LOGIN_FAIL");

      return new Promise((resolve, reject) => {
        reject(e);
      });
    });

export const activateUserLvl1 = ({ commit }, params) =>
  ActivateUserLvl1(params)
    .then(session => {
      if (session) {
        localStorage.setItem("token", session.refresh_token);
        commit("LOGIN_SUCCESS", session);
        axios.defaults.headers.common.Authorization = `Bearer ${session.access_token}`;
      } else {
        commit("LOGIN_FAIL");
      }
    })
    .catch(e => {
      commit("LOGIN_FAIL");

      return new Promise((resolve, reject) => {
        reject(e);
      });
    });

export const resetPassword = ({ commit }, email) =>
  ResetPassword(email)
    .then(() => {})
    .catch(e => new Promise((resolve, reject) => reject(e)));

export const confirmLogin = ({ commit }, params) =>
  RequestToken(params).then(session => {
    return session;
  });

export const validateActivationCode = ({ dispatch }, code) =>
  ValidateActivationCode(code)
    .then(res => {
      return res;
    })
    .catch(
      e =>
        new Promise((resolve, reject) => {
          reject(e);
        })
    );

export const getLocationsOfOrgAdmin = ({ dispatch }, params) =>
  dispatch("CheckAuth", null, { root: true }).then(() =>
    GetOrgAdminLocations(params)
      .then(res => {
        return res;
      })
      .catch(
        e =>
          new Promise((resolve, reject) => {
            reject(e);
          })
      )
  );

export const getOrganizations = ({ dispatch }) =>
  dispatch("CheckAuth", null, { root: true }).then(() =>
    GetOrganizations()
      .then(res => {
        return res;
      })
      .catch(
        e =>
          new Promise((resolve, reject) => {
            reject(e);
          })
      )
  );

export const createNewLocation = ({ dispatch }, data) =>
  dispatch("CheckAuth", null, { root: true }).then(() =>
    CreateNewLocation(data)
      .then(res => {
        return res;
      })
      .catch(
        e =>
          new Promise((resolve, reject) => {
            reject(e);
          })
      )
  );
